import { EditAction } from '../shared/enum/EditAction';
import { OriginModel } from './OriginModel';
import { PositionModel } from './PositionModel';

export interface SourceModel {
    id: number,
    codeMetric: number | null,
    position: PositionModel | null,
    origin: OriginModel | null,
    clientId: number,
    name: string,
    startOfPeriod: Date | null,
    endOfPeriod: Date | null,
    editAction: EditAction 
}

export const sourceModelInitial: SourceModel = {
    id: 0,
    codeMetric: null,
    position: null,
    origin: null,
    clientId: 0,
    name: '',
    startOfPeriod: null,
    endOfPeriod: null,
    editAction: EditAction.NONE 
};